/**
 * Algomatic - annuaire filter
 */

(function ($) {


  $('#annuaire-filter-input').on('input',function(event){
    console.log('change');
    let filter = $('#annuaire-filter-input').val().toUpperCase();
    let elements =  $('.listing__item-annuaire-container');

    // Loop through all list items, and hide those who don't match the search query
    let i =0;
    for (i = 0; i < elements.length; i++) {
      let filterText =elements[i].getAttribute('data-filter');
      if (filterText.toUpperCase().indexOf(filter) > -1) {
        elements[i].style.display = "block";
      } else {
        elements[i].style.display = "none";
      }
    }

  });
  /*
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    a = li[i].getElementsByTagName("a")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }*/



}(jQuery));
